import { Edit, Ellipsis, Trash } from '@clearkit/icons';
import {
  CKActionMenu,
  CKButton,
  CKLayoutHorizontal,
  CKPopover,
  CKSkeleton,
} from 'clearkit';

import { ButtonContainer } from '~/components/unified/ButtonContainer';

import { useProspector } from '../useProspector';
import { hasAnyFilters } from '../util';
import { ProspectorFilters } from './ProspectorFilters';
import { ProspectorSidebar } from './ProspectorSidebar';

export const SidebarFilters = () => {
  const [state, send] = useProspector();

  const { isNewList, companyQuery, personQuery } = state.context;
  const isLoading = state.matches('loading');
  const isEditingList = !isNewList;
  const title = isNewList ? 'New Prospect List' : 'Unnamed Prospect List';

  const handleSave = () => {
    send('SAVE');
  };

  const handleReset = () => {
    send('DISCARD_CHANGES');
  };

  const handleRename = () => {
    send('RENAME');
  };

  const handleDelete = () => {
    send('DELETE');
  };

  const hasFilters = hasAnyFilters({ companyQuery, personQuery });

  return (
    <ProspectorSidebar title="Filters">
      <ProspectorSidebar.Breadcrumbs>
        {isLoading ? <CKSkeleton className="h-3 w-[10ch]" /> : title}
      </ProspectorSidebar.Breadcrumbs>
      {isLoading ? null : <ProspectorFilters />}
      <ProspectorSidebar.Footer>
        <CKLayoutHorizontal>
          <ButtonContainer>
            <CKButton
              isDisabled={isLoading || !hasFilters}
              onClick={handleSave}
              variant="bold"
              variantColor="blue"
            >
              Save List...
            </CKButton>

            <CKButton isDisabled={isLoading} onClick={handleReset}>
              Discard
            </CKButton>
          </ButtonContainer>
          {isEditingList ? (
            <CKPopover
              isDisabled={!hasFilters}
              popover={
                <CKActionMenu>
                  <CKActionMenu.Item icon={<Edit />} onClick={handleRename}>
                    Rename list
                  </CKActionMenu.Item>

                  <CKActionMenu.Item
                    icon={<Trash />}
                    isDestructive
                    onClick={handleDelete}
                  >
                    Delete list
                  </CKActionMenu.Item>
                </CKActionMenu>
              }
              popoverPlacement="top-end"
            >
              <CKButton>
                <Ellipsis />
              </CKButton>
            </CKPopover>
          ) : null}
        </CKLayoutHorizontal>
      </ProspectorSidebar.Footer>
    </ProspectorSidebar>
  );
};
